import React from 'react';
import { useTheme } from '../../../theme';
import { getCurrency } from '../../../cache';
var CurrencySelector = function () {
    var css = useTheme('Header').LocaleSelector;
    var currency = getCurrency();
    return React.createElement("div", { className: css.root }, currency);
};
export default CurrencySelector;
